import React, { useState, useEffect, useRef } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import MaterialTable, {
  MaterialTableProps,
  MTableHeader,
  MTableBody,
  MTableToolbar,
} from 'material-table';
import {
  Button,
  Grid,
  TableBody,
  TableRow,
  TableCell,
  MuiThemeProvider,
  createMuiTheme,
  Card,
  CardContent,
  Typography,
} from '@material-ui/core';
import moment from 'moment';

import AdminLayout from '../../../layouts/AdminLayout';
import Spec from '../../../models/Spec';
import utils from '../../../libs/utils';

const theme = createMuiTheme({
  palette: {
    secondary: {
      light: '#ffffff',
      main: '#000000',
    },
  },
});

const Specs = (props: RouteComponentProps) => {
  const { history } = props;
  const [specs, setSpecs] = useState([] as Spec[]);
  const [isLoading, setIsLoading] = useState(false as boolean);
  const [errorMessage, setErrorMessage] = useState('' as string);

  const tableRef = useRef(null as any);

  const renderHeader = (props: any) => {
    props.columns[0].tableData.width = 'auto';

    return (
      <MuiThemeProvider theme={theme}>
        <MTableHeader {...props} />
      </MuiThemeProvider>
    );
  };
  const renderToolbar = (props: any) => {
    return (
      <div>
        <MuiThemeProvider theme={theme}>
          <MTableToolbar {...props} />
        </MuiThemeProvider>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          spacing={2}
          style={{ padding: '5px 10px' }}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                history.push('/admin/specs/create');
              }}
            >
              Create New Spec
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  };
  const renderBody = (props: any) => {
    return (
      <MuiThemeProvider theme={theme}>
        {!!errorMessage ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={4} align="center">
                <div className="text-center p-5">
                  <h2 className="m-0">Error Loading Specs</h2>
                  <p className="m-0">{errorMessage}</p>
                  <Button
                    type="button"
                    onClick={() => loadSpecs()}
                    color="primary"
                    className="mt-3"
                    variant="contained"
                  >
                    Try Again
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
            <MTableBody {...props} />
          )}
      </MuiThemeProvider>
    );
  };
  const loadSpecs = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      const result = await Spec.fetchList();
      setSpecs(result);
    }
    catch (e) {
      setErrorMessage(utils.getRequestErrorMessage(e));
    }
    finally {
      setIsLoading(false);
    }
  };

  const tableProps: MaterialTableProps<Spec> = {
    title: 'Specs',
    data: specs,
    isLoading,
    columns: [
      {
        title: 'Name',
        field: 'name',
      },
      {
        title: 'Created',
        field: 'createdAt',
        render: (data) => moment(data.createdAt).format('MMMM DD, YYYY')
      }
    ],
    localization: {
      body: {
        emptyDataSourceMessage: 'No Spec/s Found.',
      },
    },
    options: {
      headerStyle: {
        fontWeight: 'bold',
      },
      pageSize: 10,
      pageSizeOptions: [5, 10, 20, 50],
      emptyRowsWhenPaging: false,
      search: true,
      sorting: true,
      draggable: false,
      showEmptyDataSourceMessage: !isLoading,
    },
    components: {
      Header: renderHeader,
      Toolbar: renderToolbar,
      Body: renderBody,
    },
    onRowClick: (event, rowData) => {
      props.history.push(`/admin/specs/${rowData?.id}`);
    }
  };

  useEffect(() => {
    loadSpecs();
  }, []);
  return (
    <AdminLayout>
      <div className="p-4">
        <div className="pb-4">
          <Card>
            <CardContent>
              <Typography variant="h5" className="mb-3">
                Specifications Repository
              </Typography>
              <Typography>
                A central hub for exam checker specifications.
              </Typography>
            </CardContent>
          </Card>
        </div>

        <MaterialTable tableRef={tableRef} {...tableProps} />
      </div>
    </AdminLayout>
  );
};

export default withRouter(Specs);
